import { DateTime } from "luxon";
import { getParkingTimeText } from "../utils/getParkingTimeText";

export interface ParkingTimeResult {
    timeLeftText: string | null;
    isExpired: boolean;
    remainingMs: number;
}

export const calculateRemainingParkingTime = (parkingTo: string, expiredText: string = "Konec"): ParkingTimeResult => {
    const now = DateTime.now();
    const to = DateTime.fromISO(parkingTo);

    const remaining = to.diff(now).as("milliseconds");

    if (remaining <= 0) {
        return {
            timeLeftText: expiredText,
            isExpired: true,
            remainingMs: 0,
        };
    }

    return {
        timeLeftText: getParkingTimeText(remaining),
        isExpired: false,
        remainingMs: remaining,
    };
};
